export const CREATE_MEMBER_HITO = `
  mutation createMemberHito($input: CreateMemberHitoInput!, $tenant_id: Int!) {
    createMemberHito(input: $input, tenant_id: $tenant_id) {
      __typename
      ... on MemberHito {
        id
        contact_id
        hito_tipo_id
        hito_subtipo_id
        group_id
        achieved_date
        valid_from
        valid_until
        percentage
        year
        source_type
        request_id
        event_id
        metadata
        active
        created_by
        its
      }
      ... on ResultError {
        status_code
        message
        message_translation_key
      }
    }
  }
`;

export const UPDATE_MEMBER_HITO = `
  mutation updateMemberHito($input: UpdateMemberHitoInput!, $tenant_id: Int!) {
    updateMemberHito(input: $input, tenant_id: $tenant_id) {
      __typename
      ... on MemberHito {
        id
        contact_id
        hito_tipo_id
        hito_subtipo_id
        group_id
        achieved_date
        valid_from
        valid_until
        percentage
        year
        source_type
        request_id
        event_id
        metadata
        active
        created_by
        updated_by
        its
      }
      ... on ResultError {
        status_code
        message
        message_translation_key
      }
    }
  }
`;

export const DELETE_MEMBER_HITO = `
  mutation deleteMemberHito($id: Int!, $tenant_id: Int!) {
    deleteMemberHito(id: $id, tenant_id: $tenant_id) {
      __typename
      ... on MemberHito {
        id
      }
      ... on ResultError {
        status_code
        message
        message_translation_key
      }
    }
  }
`;
